/**
 * Collection of Tables
 */
class TableCollection {
  /**
   * @param {...Table} tables
   */
  constructor(...tables) {
    this.tables = tables
  }

  /**
   *
   * @param {string} id
   * @returns {Table}
   */
  findTable(id) {
    let result = this.tables.find(el => {
      return el.id === id
    })

    if (!result) {
      console.log('Table type ' + id + ' not found')
    } else {
      return result
    }
  }
}

export {TableCollection}



// WEBPACK FOOTER //
// ./src/model/table/TableCollection.js